import { DateTime } from "luxon";
import { initBookingTime } from "../../../components/BookingForm/functions/date-time.functions";
import type { NotSerializedBookingMode } from "../../Booking-Form/typings/booking-inputs";

export type ResolveDashboard2QuickBookTimesOptions = {
  bookingDate: string;
  standardStartTime: string;
  standardEndTime: string;
  mode?: NotSerializedBookingMode;
  timezone?: string;
};

export function resolveDashboard2QuickBookTimes({
  bookingDate,
  standardStartTime,
  standardEndTime,
  mode,
  timezone
}: ResolveDashboard2QuickBookTimesOptions): { startTime: string; endTime: string } {
  const zone = timezone ?? DateTime.now().zoneName;
  const todayKey = DateTime.now().setZone(zone).toFormat("yyyy-MM-dd");

  if (bookingDate === todayKey) {
    const [startTime, endTime] = initBookingTime(standardStartTime, standardEndTime, mode);

    return { startTime, endTime };
  }

  return { startTime: standardStartTime, endTime: standardEndTime };
}
